import { useQuery } from '@tanstack/react-query';
import { useTenantStore } from 'src/stores/tenant';
import getRegisteredCustomFields from 'src/services/encompass/getRegisteredCustomFields';
import { MappingSource } from 'src/components/admin/MappingsTable/utils/mappingsConstants';

export function useRegisteredCustomFields(enabled = true) {
  const tenantId = useTenantStore((state) => state.currentTenant?.id ?? '');
  return useQuery({
    queryKey: [
      '/external-fields',
      MappingSource.EncompassCustomFields,
      tenantId,
    ],
    queryFn: ({ signal }) => getRegisteredCustomFields(signal),
    enabled: enabled && Boolean(tenantId),
    retry: 1,
  });
}
